const SectionLogo = ({ position = "top-right", size = "small", opacity = 0.15 }) => {
  const sizeClasses = {
    small: "w-24 h-24 md:w-32 md:h-32",
    medium: "w-32 h-32 md:w-48 md:h-48",
    large: "w-48 h-48 md:w-64 md:h-64"
  };

  const positionClasses = {
    "top-right": "top-8 right-8",
    "top-left": "top-8 left-8",
    "bottom-right": "bottom-8 right-8",
    "bottom-left": "bottom-8 left-8",
    "center": "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
  };

  return (
    <div 
      className={`absolute ${positionClasses[position]} pointer-events-none z-0`}
      style={{ opacity }}
    >
      <img 
        src="/images/imc-shield.png"
        alt="Ice Man Cryo"
        className={`${sizeClasses[size]} object-contain`}
      />
    </div>
  );
};

export default SectionLogo;
